import type { SelectedSystemType } from 'data/types';
import type { QuotableSystemAccessoryRecommendationType } from 'features/api/accessories-api-types';
import { isDuctedBundleSystem } from 'utils/compatibility-bundle-fields';
import { buildDuctedLineSetOptions } from 'utils/ducted-accessories';
import type { DuctedLineSetScopeType } from 'utils/ducted-accessories-types';
import type { DuctedLineSetRequiredLengths } from 'utils/ducted-line-set-length';

export type BuildDuctedLineSetScopesParams = {
  system: SelectedSystemType;
  recommendations: QuotableSystemAccessoryRecommendationType[];
  requiredLengths: DuctedLineSetRequiredLengths;
};

export function buildDuctedLineSetScopes({
  system,
  recommendations,
  requiredLengths
}: BuildDuctedLineSetScopesParams): DuctedLineSetScopeType[] {
  const { condensers } = system.configuration;
  if (!isDuctedBundleSystem(system)) {
    const [condenser] = condensers;
    if (!condenser) return [];
    return [
      {
        equipmentUniqueId: system.uniqueId,
        condenser,
        options: buildDuctedLineSetOptions(recommendations),
        requiredLengthFeet: requiredLengths[condenser.uniqueId] ?? null
      }
    ];
  }
  return condensers.map((condenser) => ({
    equipmentUniqueId: condenser.uniqueId,
    condenser,
    options: buildDuctedLineSetOptions(
      recommendations.filter((rec) => rec.uniqueId === condenser.uniqueId)
    ),
    requiredLengthFeet: requiredLengths[condenser.uniqueId] ?? null
  }));
}
